import { Component, Input, OnInit } from '@angular/core';
import { AccountingModel } from './accountingModel.model';
import { EventEmitter } from '@angular/core';
import { Output } from '@angular/core';
import { UserCompanyService } from '../usercompany/usercompany.service';
import { UserCompanyModel } from '../usercompany/usercompany.model';
import { Option } from '../../../shared/models/option.model';

@Component({
    selector: 'convfact-accountingModel-form',
    templateUrl: './accountingModel-form.component.html',
    styleUrls: ['./accountingModel.component.css'],
    standalone: false
})

export class AccountingModelFormComponent implements OnInit {

  constructor(
    private userCompanyService: UserCompanyService
  ) { }

  @Input() accountingModel: AccountingModel;
  @Output() onSave = new EventEmitter<any>();
  @Input() errors: object;

  userCompany: UserCompanyModel;
  ready = false;

  public accountingModelTypeOptions: Option[] = [
    { label: 'Impuestos', value: 'impuestos' },
    { label: 'Impuestos Rectificativas', value: 'impuestosRectificativas' },
    { label: 'Ingreso', value: 'ingreso' },
    { label: 'Gasto', value: 'gasto' },
    { label: 'Cuentas financieras', value: 'cuentas_financieras' },
    { label: 'Existencias', value: 'existencias' },
    { label: 'Inmovilizado', value: 'inmovilizado' },
    { label: 'Financiación', value: 'financiacion' },
  ];

  ngOnInit() {
    this.userCompanyService.loadData().then(response => {
      this.userCompany = response;
      this.ready = true;
    })
  }

  save(accountingModel) {
    this.onSave.emit(accountingModel);
  }

  changeToggle(element) {
  }

}
